export default __webpack_public_path__ + "static/media/iconMicrosoft.8a380b05.svg";